import * as THREE from "three"

abstract class Object {
    type_id: string = "default" // Should be overriden
    instance_id = -1
    initialPosition?: THREE.Vector3
    asset?: THREE.Object3D

    constructor(position?: THREE.Vector3) {
        this.initialPosition = position
    }
    abstract getAsset(): Promise<THREE.Object3D>
}

export default Object;